import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-add-employee-dialog',
	templateUrl: './add-employee-dialog.component.html'
})
export class AddEmployeeDialogComponent implements OnInit {
	constructor(
		public dialogRef: MatDialogRef<AddEmployeeDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit(): void {}

	close(): void {
		this.dialogRef.close();
	}
}
